// extracted by mini-css-extract-plugin
export default {"root":"AddStreetAdditional_root__zGrRP","icon":"AddStreetAdditional_icon__4dlWz","text":"AddStreetAdditional_text__d7SYY"};